export default {
    task_list_columns: [
      {title: "_isClaimed" , fieldname: "isClaimed", order: 7, sort:'none'},
      {title: "_processDefName" , fieldname: "processDefName", order: 3, sort:'none'},
      {title: "_processInstDescription" , fieldname: "processInstDescription", order: 4, sort:'none'},
      {title: "_processInstId" , fieldname: "processInstId", order: 0, sort:'none'},
      {title: "_projectId", fieldname: "projectId", order: 0, sort:'none'},
      {title: "_projectName" , fieldname: "projectName", order: 1, sort:'none'},
      {title: "_taskActiveDate" , fieldname: "taskActiveDate", order: 0, sort:'none'},
      {title: "_taskDefDescription" , fieldname: "taskDefDescription", order: 0, sort:'none'},
      {title: "_taskDefId", fieldname: "taskDefId", order: 0, sort:'none'},
      {title: "_taskDefName" , fieldname: "taskDefName", order: 5, sort:'none'},
      {title: "_taskId" , fieldname: "taskId", order: 0, sort:'none'},
      {title: "_taskInstComment" , fieldname: "taskInstComment", order: 0, sort:'none'},
      {title: "_taskInstId" , fieldname: "taskInstId", order: 2, sort:'none'},
      {title: "_taskStartDate" , fieldname: "taskStartDate", order: 6, sort:'asc'},
      {title: "_userWexCapability" , fieldname: "userWexCapability", order: 0, sort:'none'}
    ],
    task_history_columns: [
      {title: "_active" , fieldname: "active", order: 0, sort:'none'},
      {title: "_user" , fieldname: "claimingUserName", order: 1, sort:'none'},
      {title: "_startTime" , fieldname: "startTime", order: 2, sort:'desc'},
      {title: "_taskName" , fieldname: "taskDefName", order: 3, sort:'none'}
    ],
    task_filepackage_columns: [
      {title: "_reviewed" , fieldname: "reviewed", order: 1, sort:'none'},
      {title: "_name" , fieldname: "name", order: 2, sort:'asc'},
      {title: "_title" , fieldname: "title", order:3, sort:'none'},
      {title: "_resLblId" , fieldname: "resLblId", order: 4, sort:'none'},
      {title: "_ditaClass" , fieldname: "ditaClass", order: 0, sort:'none'},
      {title: "_isXml" , fieldname: "isXml", order: 0, sort:'none'},
      {title: "_lineageId" , fieldname: "lineageId", order: 0, sort:'none'},
      {title: "_mimeType" , fieldname: "mimeType", order: 0, sort:'none'},
      {title: "_resPathId" , fieldname: "resPathId", order: 0, sort:'none'},
      {title: "_rootElementName" , fieldname: "rootElementName", order: 0, sort:'none'},
      {title: "_verNum" , fieldname: "verNum", order: 0, sort:'none'},
      {title: "_verCreateDate" , fieldname: "verCreateDate", order: 0, sort:'none'},
      {title: "_verCreator" , fieldname: "verCreator", order: 0, sort:'none'}
    ],
    editor_filepackage_columns: [
      {title: "_reviewed" , fieldname: "reviewed", order: 1, sort:'none'},
      {title: "_name" , fieldname: "name", order: 2, sort:'asc'},
      {title: "_title" , fieldname: "title", order:0, sort:'none'},
      {title: "_resLblId" , fieldname: "resLblId", order: 0, sort:'none'},
      {title: "_ditaClass" , fieldname: "ditaClass", order: 0, sort:'none'},
      {title: "_isXml" , fieldname: "isXml", order: 0, sort:'none'},
      {title: "_lineageId" , fieldname: "lineageId", order: 0, sort:'none'},
      {title: "_mimeType" , fieldname: "mimeType", order: 0, sort:'none'},
      {title: "_resPathId" , fieldname: "resPathId", order: 0, sort:'none'},
      {title: "_rootElementName" , fieldname: "rootElementName", order: 0, sort:'none'},
      {title: "_verNum" , fieldname: "verNum", order: 0, sort:'none'},
      {title: "_verCreateDate" , fieldname: "verCreateDate", order: 0, sort:'none'},
      {title: "_verCreator" , fieldname: "verCreator", order: 0, sort:'none'}
    ],
    selectfile_dialog_columns: [
      {title: "_name" , fieldname: "name", order: 1, sort:'asc'},
      {title: "_size" , fieldname: "size", order: 2, sort:'none'},
      {title: "_mimeType" , fieldname: "mimeType", order: 3, sort:'none'}
    ],
    search_columns:  [
      {title: "_name" , fieldname: "name", order: 1, sort:'asc'},
      {title: "_title" , fieldname: "title", order:0, sort:'none'},
      {title: "_resLblId" , fieldname: "resLblId", order: 0, sort:'none'},
      {title: "_ditaClass" , fieldname: "ditaClass", order: 0, sort:'none'},
      {title: "_isXml" , fieldname: "isXml", order: 0, sort:'none'},
      {title: "_lineageId" , fieldname: "lineageId", order: 0, sort:'none'},
      {title: "_mimeType" , fieldname: "mimeType", order: 3, sort:'none'},
      {title: "_resPathId" , fieldname: "resPathId", order: 0, sort:'none'},
      {title: "_rootElementName" , fieldname: "rootElementName", order: 0, sort:'none'},
      {title: "_verNum" , fieldname: "verNum", order: 0, sort:'none'},
      {title: "_verCreateDate" , fieldname: "verCreateDate", order: 0, sort:'none'},
      {title: "_verCreator" , fieldname: "verCreator", order: 0, sort:'none'},
      {title: "_folderPath" , fieldname: "folderPath", order: 2, sort:'none'}
    ],
    browse_columns:  [
      {title: "_name" , fieldname: "name", order: 2, sort:'asc'},
      {title: "_title" , fieldname: "title", order:3, sort:'none'},
      {title: "_resLblId" , fieldname: "resLblId", order: 4, sort:'none'},
      {title: "_ditaClass" , fieldname: "ditaClass", order: 0, sort:'none'},
      {title: "_isXml" , fieldname: "isXml", order: 0, sort:'none'},
      {title: "_lineageId" , fieldname: "lineageId", order: 0, sort:'none'},
      {title: "_mimeType" , fieldname: "mimeType", order: 0, sort:'none'},
      {title: "_resPathId" , fieldname: "resPathId", order: 0, sort:'none'},
      {title: "_rootElementName" , fieldname: "rootElementName", order: 0, sort:'none'},
      {title: "_verNum" , fieldname: "verNum", order: 0, sort:'none'},
      {title: "_verCreateDate" , fieldname: "verCreateDate", order: 0, sort:'none'},
      {title: "_verCreator" , fieldname: "verCreator", order: 0, sort:'none'}
    ]
};
